import React from "react";
import SEO from "../components/shared/SEO";
import DashboardNavbar from "../components/shared/DashboardNavbar";
import MyBlogsHero from "../components/dashboard/MyBlogsHero";
import MyBlogsList from "../components/dashboard/MyBlogsList";

export default function MyBlogs() {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <SEO
        title="My Blogs | SoloConnect"
        description="View, manage, and organize all your published travel blogs on SoloConnect."
        keywords="my blogs, published blogs, travel blog dashboard, SoloConnect"
      />
      <DashboardNavbar />
      <main className="flex-grow">
        <MyBlogsHero />
        <MyBlogsList />
      </main>
    </div>
  );
}
